export const bancosBrazil = [
  {nombre: 'Banco do Brasil S.A.', id: "001"},
  {nombre: 'Banco Itaú S.A.', id: "341"},
  {nombre: 'Banco Santander (Brasil) S.A.', id: "033"},
  {nombre: 'Banco Bradesco S.A.', id: "237"},
  {nombre: 'Next Tecnologia e Serviços Digitais', id: "237"},
  {nombre: 'Caixa Econômica Federal', id: "104"},
  {nombre: 'Banco Safra S.A.', id: "422"},
  {nombre: 'Banco Cooperativo Sicredi S.A.', id: "748"},
  {nombre: 'Banco do Estado do Rio Grande do Sul S.A. BANRISUL', id: "041"},

  {nombre: 'BANCO BTG PACTUAL S.A.', id: "208"},
  {nombre: 'Neon Pagamentos', id: "655"},
  {nombre: 'Banco Inter S.A.', id: "077"},
  {nombre: 'Banco Agibank S.A.', id: "121"},
  {nombre: 'Banco Original S.A.', id: "212"},
  {nombre: 'Nubank', id: "260"},
  {nombre: 'Banco C6 S.A.', id: "336"},
  {nombre: '	Banco BV (Before Banco Votorantim)', id: "413"}
];

export const bancosChile = [
  {nombre: 'Banco Del Estado De Chile', id: "012"},
  {nombre: 'Banco Bbva ( Bilbao Vizcaya Argentaria Chile) / Banco Bhif', id: "504"},
  {nombre: 'Banco Bice', id: "028"},
  {nombre: 'Banco Consorcio', id: "055"},
  {nombre: 'Banco Corpbanca', id: "027"},
  {nombre: 'Banco De Chile / Banco A. Edwards / Credichile / Citybank', id: "001"},
  {nombre: 'Banco De Crédito E Inversiones (BCI) / Tbanc', id: "016"},
  {nombre: 'Banco Del Desarrollo.', id: "507"},
  {nombre: 'Banco Falabella', id: "051"},

  {nombre: 'Banco Internacional.', id: "009"},
  {nombre: 'Banco Itau Chile / Bank Boston', id: "039"},
  {nombre: 'Banco Ripley', id: "053"},
  {nombre: 'Banco París', id: "057"},
  {nombre: 'Banco Santander – Santiago / Banco Santander / Banefe', id: "037"},
  {nombre: 'Banco Security', id: "049"},
  {nombre: 'Coopeuch', id: "672"},
  {nombre: 'Hsbc Bank (Chile)', id: "031"},
  {nombre: 'Scotiabank / Sud – Americano', id: "014"}
];

export const bancosMexico = [
  {nombre: 'BANCOMEXT', id: "37006"},
  {nombre: 'BANOBRAS', id: "37009"},
  {nombre: 'BANJERCITO', id: "37019"},
  {nombre: 'NAFIN', id: "37135"},
  {nombre: 'BANSEFI', id: "37166"},
  {nombre: 'HIPOTECARIA FED', id: "37168"},
  {nombre: 'BANAMEX', id: "40002"},
  {nombre: 'BBVA BANCOMER', id: "40012"},
  {nombre: 'SANTANDER', id: "40014"},

  {nombre: 'HSBC', id: "40021"},
  {nombre: 'BAJIO', id: "40030"},
  {nombre: 'INBURSA', id: "40036"},
  {nombre: 'MIFEL', id: "40042"},
  {nombre: 'SCOTIABANK', id: "40044"},
  {nombre: 'BANREGIO', id: "40058"},
  {nombre: 'INVEX', id: "40059"},
  {nombre: 'BANSI', id: "40060"},
  {nombre: 'AFIRME', id: "40062"},

  {nombre: 'BANORTE', id: "40072"},
  {nombre: 'ACCENDO BANCO', id: "40102"},
  {nombre: 'AMERICAN EXPRESS', id: "40103"},
  {nombre: 'BANK OF AMERICA', id: "40106"},
  {nombre: 'MUFG', id: "40108"},
  {nombre: 'JP MORGAN', id: "40110"},
  {nombre: 'BMONEX', id: "40112"},
  {nombre: 'VE POR MAS', id: "40113"},
  {nombre: 'DEUSTCHE', id: "40124"},
  {nombre: 'CREDIT SUISSE', id: "40126"},
  {nombre: 'AZTECA', id: "40127"},
  {nombre: 'AUTOFIN', id: "40128"},

  {nombre: 'BARCLAYS', id: "40129"},
  {nombre: 'COMPARTAMOS', id: "40130"},
  {nombre: 'BANCO FAMSA', id: "40131"},
  {nombre: 'MULTIVA BANCO', id: "40132"},
  {nombre: 'ACTINVER', id: "40133"},
  {nombre: 'INTERCAM BANCO', id: "40136"},
  {nombre: 'BANCOPPEL', id: "40137"},
  {nombre: 'ABC CAPITAL', id: "40138"},
  {nombre: 'CONSUBANCO', id: "40140"},
  {nombre: 'VOLKSWAGEN', id: "40141"},
  {nombre: 'CIBANCO', id: "40143"},
  {nombre: 'BBASE', id: "40145"},

  {nombre: 'BANKAOOL', id: "40147"},
  {nombre: 'PAGATODO', id: "40148"},
  {nombre: 'INMOBILIARIO', id: "40150"},
  {nombre: 'DONDE', id: "40151"},
  {nombre: 'BANCREA', id: "40152"},
  {nombre: 'BANCO FINTERRA', id: "40154"},
  {nombre: 'ICBC', id: "40155"},
  {nombre: 'SABADELL', id: "40156"},
  {nombre: 'SHINHAN', id: "40157"},
  {nombre: 'MIZUHO BANK', id: "40158"},
  {nombre: 'BANCO S3', id: "40160"},
  {nombre: 'MONEXCB', id: "90600"},

  {nombre: 'GBM', id: "90601"},
  {nombre: 'MASARI', id: "90602"},
  {nombre: 'VALUE', id: "90605"},
  {nombre: 'ESTRUCTURADORES', id: "90606"},
  {nombre: 'VECTOR', id: "90608"},
  {nombre: 'CBOLSA', id: "90613"},
  {nombre: 'FINAMEX', id: "90616"},
  {nombre: 'VALMEX', id: "90617"},
  {nombre: 'PROFUTURO', id: "90620"},
  {nombre: 'CB INTERCAM', id: "90630"},
  {nombre: 'CI BOLSA', id: "90631"},
  {nombre: 'FINCOMUN', id: "90634"},
  {nombre: 'HDI SEGUROS', id: "90636"},
  {nombre: 'AKALA', id: "90638"},
  {nombre: 'REFORMA', id: "90642"},
  {nombre: 'STP', id: "90646"},
  {nombre: 'EVERCORE', id: "90648"},
  {nombre: 'CREDICAPITAL', id: "90652"},
  {nombre: 'KUSPIT', id: "90653"},
  {nombre: 'UNAGRA', id: "90656"},
  {nombre: 'ASP INTEGRA OPC', id: "90659"},
  {nombre: 'CB LIBERTAD', id: "90670"},
  {nombre: 'CAJA POP MEXICA', id: "90677"},
  {nombre: 'CRISTOBAL COLON', id: "90680"},
  {nombre: 'CAJA TELEFONIST', id: "90683"},
  {nombre: 'TRANSFER', id: "90684"},
  {nombre: 'FONDO (FIRA)', id: "90685"},
  {nombre: 'INVERCAP', id: "90686"},
  {nombre: 'FOMPED', id: "90689"},
  {nombre: 'INDEVAL', id: "90902"},
  {nombre: 'CoDi Valida', id: "90903"}
];

export const bancosColombia = [
  {nombre: 'BANCO DE BOGOTA', id: "0001"},
  {nombre: 'BANCO POPULAR', id: "0002"},
  {nombre: 'BANCO CORPBANCA COLOMBIA SA.', id: "0006"},
  {nombre: 'BANCOLOMBIA', id: "0007"},
  {nombre: 'CITIBANK', id: "0009"},
  {nombre: 'BANCO GNB SUDAMERIS', id: "0012"},
  {nombre: 'BBVA COLOMBIA', id: "0013"},
  {nombre: 'BANCO COLPATRIA', id: "0019"},
  {nombre: 'BANCO DE OCCIDENTE', id: "0023"},

  {nombre: 'BANCOLDEX', id: "0031"},
  {nombre: 'BANCO BCSC SA (Banco Caja Social)', id: "0032"},
  {nombre: 'BANCO AGRARIO', id: "0040"},
  {nombre: 'JPMORGAN CORPORACION FINANCIERA', id: "0041"},
  {nombre: 'BNP PARIBAS', id: "0042"},
  {nombre: 'BANCO DAVIVIENDA S.A.', id: "0051"},
  {nombre: 'BANCO AV VILLAS', id: "0052"},
  {nombre: 'BANCO PROCREDIT', id: "0058"},
  {nombre: 'BANCO PICHINCHA', id: "0060"},

  {nombre: 'BANCOOMEVA', id: "0061"},
  {nombre: 'BANCO FINANDINA', id: "0063"},
  {nombre: 'BANCO SANTANDER DE NEGOCIOS COLOMBIA SA', id: "0065"},
  {nombre: 'BANCO COOPERATIVO COOPCENTRAL', id: "0066"},
  {nombre: 'COMPENSAR', id: "0083"},
  {nombre: 'GESTION CONTACTO', id: "0084"},
  {nombre: 'ASOPAGOS', id: "0086"},
  {nombre: 'FEDECAJAS', id: "0087"},
  {nombre: 'SIMPLE S.A', id: "0088"},
  {nombre: 'ENLACE OPERATIVO', id: "0089"},
  {nombre: 'COOPERTIVA FINANCIERA ANTIOQUIA', id: "0283"},
  {nombre: 'COTRAFA COOPERATIVA FINANCIERA', id: "0289"},

  {nombre: 'CONFIAR', id: "0292"},
  {nombre: 'COLTEFINANCIERA S.A', id: "0370"},
  {nombre: 'DECEVAL', id: "0550"},
  {nombre: 'DGCPTN', id: "0683"},
  {nombre: 'DGCPTN * Sistema General de Regalias', id: "0685"},
  {nombre: 'FINANCIERA JURISCOP S.A. Compañía de Financiamiento', id: "0121"},
  {nombre: 'BANCO MULTIBANK S.A.', id: "0064"},
  {nombre: 'BANCO COMPARTIR S.A.', id: "0067"},
  {nombre: 'BANCO FALABELLA S.A.', id: "0062"},
  {nombre: 'SERFINANSA S.A', id: "0069"},
];

export const bancosEcuador = [
  {nombre: 'BANCO AMAZONAS', id: "0001"},
  {nombre: 'BANCO BOLIVARIANO', id: "0002"},
  {nombre: 'BANCO CAPITAL', id: "0003"},
  {nombre: 'BANCO CENTRAL DEL ECUADOR', id: "0004"},
  {nombre: 'BANCO CITY BANK', id: "0005"},
  {nombre: 'BANCO COFIEC', id: "0006"},
  {nombre: 'BANCO COOPNACIONAL SA', id: "0007"},
  {nombre: 'BANCO D MIRO SA', id: "0008"},
  {nombre: 'BANCO DE FOMENTO', id: "0009"},

  {nombre: 'BANCO DE GUAYAQUIL S.A', id: "0010"},
  {nombre: 'BANCO DE LA PRODUCCION', id: "0011"},
  {nombre: 'BANCO DE LOJA', id: "0012"},
  {nombre: 'BANCO DEL AUSTRO', id: "0013"},
  {nombre: 'BANCO DEL INSTITU ECUATORIANO DE SEGURIDAD SOCIAL', id: "0014"},
  {nombre: 'BANCO DEL LITORAL S.A.', id: "0015"},
  {nombre: 'BANCO DEL PACIFICO', id: "0016"},
  {nombre: 'BANCO DELBANK S.A.', id: "0017"},
  {nombre: 'BANCO ECUATORIANO DE LA VIVIENDA', id: "0018"},

  {nombre: 'BANCO GENERAL RUMINAHUI S.A.', id: "0019"},
  {nombre: 'BANCO INTERNACIONAL', id: "0020"},
  {nombre: 'BANCO MACHALA', id: "0021"},
  {nombre: 'BANCO PARA LA ASISTENCIA COMUNITARIA FINCA S.A.', id: "0022"},
  {nombre: 'BANCO PICHINCHA C.A.', id: "0023"},
  {nombre: 'BANCO PROCREDIT S.A.', id: "0024"},
  {nombre: 'BANCO PROMERICA S.A.', id: "0025"},
  {nombre: 'BANCO SOLIDARIO', id: "0026"},
  {nombre: 'BANCO SUDAMERICANO', id: "0027"},
];

export const bancosPeru = [
  {nombre: 'BANCO INTERNACIONAL DEL PERU (INTERBANK)', id: "0001"},
  {nombre: 'BANCO BBVA PERU', id: "0002"},
  {nombre: 'BANCO BCP PERU', id: "0003"},
  {nombre: 'BANCO SCOTIABANK PERU', id: "0004"},
  {nombre: 'BANCO INTERAMERICANO DE FINANZAS', id: "0005"},
  {nombre: 'PICHINCHA', id: "0006"},
  {nombre: 'MIBANCO', id: "0007"},
  {nombre: 'BANCO DE LA NACION', id: "0008"},
  {nombre: 'BANCO DE COMERCIO', id: "0009"},
  {nombre: 'BANCO SANTANDER', id: "0010"},
  {nombre: 'CITIBANK DEL PERU', id: "0011"}
]